import React from "react";
import "../../assets/css/destinations.css";
import { motion } from "framer-motion";

export default function Destination() {

  const places = [
    { name: "Goa", img: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2" },
    { name: "Daman", img: "https://images.unsplash.com/photo-1589308078059-be1415eab4c3" },
    { name: "Kerala", img: "https://images.unsplash.com/photo-1501785888041-af3ef285b470" },
    { name: "Sikkim", img: "https://images.unsplash.com/photo-1544735716-392fe2489ffa" },
    { name: "Ujjain", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpdfsXax0vWAj8UQy9YetnWekfQPn4iLbETg&s" },
    { name: "Rajasthan", img: "https://images.unsplash.com/photo-1599661046289-e31897846e41" }
  ];

  return (
    <section className="destinations">

      {/* Background Glow */}
      <div className="bg-blur one"></div>
      <div className="bg-blur two"></div>

      <div className="dest-container">

        {/* Heading */}
        <motion.h2
          className="dest-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          Our Popular <span>Destinations</span>
        </motion.h2>

        <motion.p 
          className="dest-sub"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          🇮🇳 Explore India's Most Loved Travel Spots
        </motion.p>

        {/* Cards */}
        <div className="dest-grid">
          {places.map((place, i) => (
            <motion.div
              className="dest-card"
              key={i}
              whileHover={{ scale: 1.06 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <img src={place.img} alt={place.name} />

              <div className="overlay">
                <h3>{place.name}</h3>
                <p>Explore Now →</p>
              </div>

              {/* Glow Border */}
              <div className="card-glow"></div>
            </motion.div>
          ))}
        </div>

      </div>

    </section>
  );
}